export interface NuanceSpeechkitPlugin {
  echo(options: { value: string }): Promise<{ value: string }>;
  initSpeechKit(options: InitSpeechKitOptions): Promise<void>;
  start(options: InputOptions): Promise<{ text: string }>;
}
export interface InitSpeechKitOptions {
  applicationName: string;
  partnerGuid: string;
  organizationToken: string;
  userName: string;
}
export interface InputOptions {
  text: string;
}